export const defaultLocale = 'lv-LV';